package com.evoapps.evoshift.domain.schedule.ai

/**
 * SH-90: why the AI step could not help. The server answers with an HttpsError code and
 * `details.reason` (functions/aiAssign.js REASONS); the data layer maps those, never messages.
 */
enum class AiAssignFailure {
    /** Switched off (Remote Config kill switch `ai_auto_assign_enabled`) or not set up. */
    DISABLED,
    /** The workplace's plan has ended (AI is part of the plan). */
    PLAN_REQUIRED,
    /** Only the workplace's owner and managers may ask. */
    NOT_ALLOWED,
    /** The owner's AI requests for today are used up. */
    QUOTA_EXCEEDED,
    /** The month is larger than the AI step takes (AiScheduleLimits). */
    TOO_LARGE,
    /** The server refused the request's shape. */
    INVALID_REQUEST,
    /** The model failed or took too long (the request was refunded). */
    MODEL_FAILED,
    /** No connection or anything else. */
    UNKNOWN
}

class AiAssignException(val failure: AiAssignFailure, cause: Throwable? = null) :
    Exception("AI auto-assign failed: $failure", cause)

/** Whether AI suggestions are offered at a workplace now (the server's view). */
data class AiAssignStatus(val enabled: Boolean, val remainingToday: Int)
